import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ImportService {
  private _importInProgress = new BehaviorSubject<boolean>(false);
  importInProgress$ = this._importInProgress.asObservable();

  setImportInProgress(val: boolean) {
    this._importInProgress.next(val);
  }
}
